module.exports = __webpack_public_path__ + "img/33_69.00938927.png";